<template>
	<section class="section-card" v-loading="loading">
		<div class="section-head">
			<h2 class="section-title">关联采集设备</h2>
		</div>

		<div class="table-box">
			<gc-table border :columns="columns" :table-data="relatedDevices" :total-hide="false" />
		</div>
	</section>
</template>

<script>
import { apiGetPressureRegulatorRuntimeRecords } from '@/apis/pressureRegulatorManage.api'

export default {
	name: 'RelatedDevicesSection',
	data() {
		return {
			loading: false,
			relatedDevices: [],
			columns: [
				{ key: 'deviceTypeName', name: '设备类型', tooltip: true },
				{
					key: 'designNo',
					name: '外观编号',
					tooltip: true,
					render: (h, row) =>
						h(
							'span',
							{
								class: 'data-table__link',
								on: {
									click: () => this.goDeviceDetail(row),
								},
							},
							row.designNo || '--',
						),
				},
				{ key: 'subDeviceNo', name: '通道号', tooltip: true },
				{
					key: 'statusRecords',
					name: '采集参数',
					tooltip: true,
					render: (h, row) => h('span', this.formatStatusRecords(row.statusRecords)),
				},
				{
					key: 'deviceStatus',
					name: '状态',
					tooltip: true,
					render: (h, row) =>
						h(
							'span',
							{ class: `status-pill status-pill--${this.getDeviceStatusKey(row.deviceStatus)}` },
							row.deviceStatusName || this.formatDeviceStatus(row.deviceStatus),
						),
				},
			],
		}
	},
	props: {
		collectorDeviceNo: {
			type: [String, Number],
			default: '',
		},
	},
	watch: {
		collectorDeviceNo: {
			handler(value) {
				if (value) {
					this.getRelatedDevices()
				} else {
					this.relatedDevices = []
				}
			},
			immediate: true,
		},
	},
	methods: {
		async getRelatedDevices() {
			this.loading = true
			try {
				const runtimeRecords = await apiGetPressureRegulatorRuntimeRecords({
					collectorDeviceNo: this.collectorDeviceNo,
				})
				this.relatedDevices = runtimeRecords || []
			} finally {
				this.loading = false
			}
		},
		formatStatusRecords(records) {
			if (!records || !records.length) return '--'
			return records
				.map(item => item.name)
				.filter(Boolean)
				.join('、')
		},
		formatDeviceStatus(status) {
			const statusMap = {
				0: '待安装',
				1: '已安装',
				2: '已拆除',
			}
			return statusMap[status] || (status === null || status === undefined || status === '' ? '--' : status)
		},
		getDeviceStatusKey(status) {
			const statusMap = {
				0: 'pending',
				1: 'success',
				2: 'danger',
			}
			return statusMap[status] || 'pending'
		},
		goDeviceDetail(device) {
			if (!device.deviceId) {
				this.$message.warning('缺少设备ID，暂无法跳转设备详情')
				return
			}
			this.$router.push({
				path: '/device/detail',
				query: {
					deviceId: device.deviceId,
					deviceType: device.deviceTypeId,
				},
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.section-card {
	position: relative;
	padding: 22px 24px 24px;
	background: var(--panel-bg);
	border: 1px solid var(--panel-border);
	border-radius: 12px;
	box-shadow: var(--panel-shadow);
	backdrop-filter: blur(12px);
}

.section-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 18px;
}

.section-title {
	margin: 0;
	color: var(--title);
	font-size: 17px;
	font-weight: 700;
	letter-spacing: 0.01em;
}

::v-deep .data-table__link {
	color: #2563eb;
	font-weight: 400;
	cursor: pointer;
}

.table-box {
	height: 500px;
}

::v-deep .status-pill {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-height: 24px;
	padding: 2px 10px;
	border-radius: 999px;
	font-size: 14px;
	font-weight: 400;
	white-space: nowrap;
}

::v-deep .status-pill--success {
	background: #dcfce7;
	color: #16a34a;
}

::v-deep .status-pill--pending {
	background: #f1f5f9;
	color: #64748b;
}

::v-deep .status-pill--danger {
	background: #fee2e2;
	color: #dc2626;
}

@media (max-width: 900px) {
	.section-head {
		flex-direction: column;
		align-items: flex-start;
	}
}
</style>
